// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","wrapper":"fuxecYJ9I2u4s9-GMVAif","has-description":"_2l2Avvw6wmeWyBjQhR435y","description":"_3aFr8H3Ee2I5uiAO4-sxlW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Module/components/StepTitle.mod.css
// module id = 1691
// module chunks = 0